import { useEffect, useState } from 'react';
import { CardText, Col, Form, Row, Stack } from 'react-bootstrap';
import Card from 'react-bootstrap/Card';
import gitlogo from './assets/github-mark.png';
import urlLink from '../assets/expand-arrows.png';
import { Link,useNavigate } from 'react-router-dom';
import UiBase from '../../base/UiBase';
//import props from './../../base/interfaces/project';
import { ButtonComponent } from '../Buttons/ButtonComponent';
import ProjectAPI from '../../api/ProjectsAPI';
type Props={
  id:string|number;
  login:boolean;
  url:string;
  externalLink:string;
  name:string;
  description:string;
  views:number;
  repositoryClicks:number;
  externalLinkClicks:number;
  project:Record<string,any>|null;
}
export default function ProjectCard(props:Props){
  const id=props.id;
  var disableStyle='';
  const base=new UiBase();
  const login=props.login;
  const navigate = useNavigate();
  const project=new ProjectAPI();
  const [url,setUrl]=useState(false);
  const [externalLink,setExternalLink]=useState(false);
  const EXCLUDED_TAGS = new Set(['img', 'picture', 'video', 'audio', 'source', 'track', 'embed', 'object', 'iframe', 'a']);
  const showGitLogo=(url:String)=>{
    if(url!==""){
      setUrl(true);
    }else setUrl(false);
  }
  const showExternalLink=(url:String="")=>{
    if(url!==""){
      setExternalLink(true);
    }else setExternalLink(false);
  }
  const disableLink=()=>{
    const disable='disabled-link';
    if(id===0){
      disableStyle=disable;
    }
  }
  const deleteProject=async(obj: any)=>{
    const id=obj.id;
    const del=await project.deleteProject(id);
    if(del?.status==200){
      navigate(0);
    }
  }
  const repositoryHandle=async()=>{
    const request=await project.metricCount(id,'click');
  }
  const externalHandle=async()=>{
    const request=await project.metricCount(id,'externalLink');
  }
  const descriptionDisplay=(description:string)=>{
    if(description.startsWith('<')&&description.endsWith('>')){
      const tempDiv=document.createElement('div');
      tempDiv.innerHTML=description;
      const firstPara = tempDiv.querySelectorAll('p');
      for(let i=0; i<firstPara.length; i++){
        if(firstPara[i].innerText.trim().length>0){
          description=base.util.cutOffString(firstPara[i].innerText.trim()||'',100," ....");
          break;
        }
      }
    }
    else
    {
      description=base.util.cutOffString(description,100," ....")
    }
    return description;
  }
  useEffect(()=>{
    showGitLogo(props.url);
    showExternalLink(props.externalLink);
    disableLink();
  });
  return (
    <div>
    <Row>
    <Col>
    <Card style={{minHeight:'11rem',backgroundColor:'	#FFFAFA'}}>
    <Card.Body>
    <Link to={'/project/'+id} className={disableStyle} state={{record:props.project}}>
    <Card.Title as="h4">{props.name}</Card.Title>
    <CardText>{descriptionDisplay(props.description)}</CardText>
    </Link>
    <div>
    {
      url?
      <Card.Link onClick={repositoryHandle} href={props.url}><img src={gitlogo} height={30} width={30} alt="Repistory"/></Card.Link>
      :null
    }
    {externalLink?
    <Card.Link onClick={externalHandle} href={props.externalLink}><img src={urlLink} height={30} width={30} alt="External Link"/></Card.Link>
    :null
    }
    {
      login?
      <div className='inlineblock'>
      <Form.Label className='inlineblock'>Views</Form.Label>
      <p className='inlineblock'>{props.views}</p>
      <Form.Label className='inlineblock'>GitHub Clicks:</Form.Label>
      <p className='inlineblock'>{props.repositoryClicks}</p>
      <Form.Label className='inlineblock'>Link Clicks:</Form.Label>
      <p className='inlineblock'>{props.externalLinkClicks||0}</p>
      </div>
      
      :null
    }
    </div>
    <div>
    {login?
    <>
    
    <Stack direction="horizontal" gap={1}>
    <Link to={"/form/project/"+id} state={{record:props.project}}><ButtonComponent id={""} caption={'Update'} variant={''} onClick={undefined} size={''} active={false} disabled={false} type={undefined} /></Link>
  
    <Link to={"/project/view-statistics/"+id} state={{record:props.project}}><ButtonComponent id={""} caption={'Statistcs'} variant={''} onClick={undefined} size={''} active={false} disabled={false} type={undefined} /></Link>
   
    <Link to={""} state={{login:login}} onClick={()=>deleteProject({id})}><ButtonComponent id={""} caption={'Delete'} variant={'danger'} onClick={undefined} size={''} active={false} disabled={false} type={undefined} /></Link>
    </Stack>
    
    </>
    :null}
    </div>
    
    </Card.Body>
    
    </Card>
    </Col>
    </Row>
    </div>);
}
